function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

import qs from 'query-string';
import { API_ENDPOINT } from '../config';
import { ErrorBadRequest, ErrorTimeout, ErrorUnavailable } from './errors';
export { ErrorTimeout, ErrorUnavailable };
export var EVENT_TYPE_BIRTH = 'birth';
export var EVENT_TYPE_DEATH = 'death';
export var ORDER_TYPE_ASCENDING = 'ascending';
export var ORDER_TYPE_DESCENDING = 'descending';
export var DEFAULT_EVENT_TYPE = EVENT_TYPE_BIRTH;
export var DEFAULT_ORDER_TYPE = ORDER_TYPE_ASCENDING;
var FETCH_TIMEOUT = 10000;

function buildURL(root, parameters) {
  return "".concat(API_ENDPOINT).concat(root, "?").concat(qs.stringify(parameters));
}

function timeoutFetch(url) {
  return new Promise(function (resolve, reject) {
    var controller = null;

    try {
      controller = new AbortController();
    } catch (e) {// AbortController not available (observed on Firefox ESR 52)
    }

    var signal = null,
        timer = null;

    if (controller !== null) {
      signal = controller.signal;
      timer = setTimeout(function () {
        controller.abort();
        reject(new ErrorTimeout());
      }, FETCH_TIMEOUT);
    }

    fetch(url, signal !== null ? {
      signal: signal
    } : undefined).then(function (result) {
      return result.json();
    }).then(function (value) {
      if (timer !== null) {
        clearTimeout(timer);
      }

      if (value.code >= 200 && value.code < 400) {
        // OK
        resolve(value);
      } else if (value.code === 503) {
        reject(new ErrorUnavailable(value.information)); // This string field is an optional
      } else {
        reject(new ErrorBadRequest("HTTP ".concat(value.code))); // Typically 4XX or 5XX errors
      }
    }).catch(function (reason) {
      if (reason instanceof SyntaxError) {
        reject(new ErrorBadRequest('Invalid JSON')); // Not json (indicates a major issue)
      } else {
        if (timer !== null) {
          clearTimeout(timer);
        }

        reject(reason); // Probably timeout, no connection to server or cross origin policy issue
      }
    });
  });
}

export function getPersons(offset, limit, surname, name, placeId, eventType, afterYear, beforeYear, orderType) {
  return timeoutFetch(buildURL('/persons', {
    offset: offset,
    limit: limit,
    surname: surname,
    name: name,
    place: placeId,
    event: eventType,
    after: afterYear,
    before: beforeYear,
    order: orderType
  }));
}
export function getPlaces(limit, queryPrefix) {
  return timeoutFetch(buildURL('/places', {
    limit: limit,
    prefix: queryPrefix
  }));
}
export function getStatisticsGeography(surname, name) {
  return timeoutFetch(buildURL('/stats/geography', {
    surname: surname,
    name: name
  }));
}
export function getStatisticsTime(surname, name, placeId, eventType) {
  return timeoutFetch(buildURL('/stats/time', {
    surname: surname,
    name: name,
    place: placeId,
    event: eventType
  })).then(function (data) {
    return data.results ? _objectSpread(_objectSpread({}, data), {}, {
      results: data.results.filter(function (_ref) {
        var name = _ref.name;
        return name !== '1850';
      })
    }) : data;
  });
}